import React from 'react'
import './Header.css'
import Logo from '../../assets/logo.png'

const Header = () => {
  return (
    <div>
      <div className="header">
        <img src={Logo} alt="" className="logo"></img>
       

        <ul className="headerMenu">
          <li>Home</li>
          <li>Programs</li>
          <li>Why us</li>
          <li>Plans</li>
         
        </ul>

      </div>
    </div>
  )
}

export default Header
